import { createBrowserClient } from '@supabase/ssr';
import { getConfig } from '../config/env';

export function createClient() {
  const config = getConfig().supabase;
  
  // Handle missing Supabase configuration gracefully
  // This allows the app to work even if Supabase isn't configured (e.g., for tenant sites that don't need auth)
  if (!config.url || !config.anonKey) {
    // Return a mock client that won't crash but won't work either
    // This is better than crashing the entire app
    console.warn(
      '[Supabase] Missing configuration. Supabase features will be disabled. ' +
      'Set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY environment variables to enable.'
    );
    
    // Create a client with placeholder values - it will fail gracefully on use
    return createBrowserClient(
      config.url || 'https://placeholder.supabase.co',
      config.anonKey || 'placeholder-key'
    );
  }
  
  return createBrowserClient(
    config.url,
    config.anonKey
  );
}

